import {AiOutlineUser,AiFillFile,AiOutlineDownload, AiFillSetting, AiFillCloud} from 'react-icons/ai';
import {ImPriceTag} from 'react-icons/im';
import {FaHeadphonesAlt} from 'react-icons/fa';
import {RiCheckboxBlankFill} from 'react-icons/ri';
export const priceData1=[
    {
     icon:<AiOutlineUser />,
     title:"Start with 1 user"
    },
    {
     icon:<AiFillFile />,
    title:"1 project"
    },
    {
    icon:<AiFillFile />,
    title:"1 active user test"
    }
]
export const priceData2=[
    {
     icon:<AiOutlineUser />,
     title:"Start with 1 user"
    },
    {
     icon:<AiFillFile />,
    title:"Unlimited Projects"
    },
    {
    icon:<AiFillFile />,
    title:"1 active user test"
    },
    {
     icon:<AiOutlineDownload />,
     title:"Download prototypes or designs"
    },
    {
    icon:<ImPriceTag />,
    title:"Remove HostDesign branding"
    }
]
export const priceData3=[
    {
     icon:<AiOutlineUser />,
     title:"Start with 3 users"
    },
    {
     icon:<AiFillFile />,
    title:"Unlimited Projects"
    },
    {
    icon:<AiFillFile />,
    title:"10 active user test"
    },
    {
     icon:<AiOutlineDownload />,
     title:"Download prototypes or designs"
    },
    {
    icon:<ImPriceTag />,
    title:"Remove HostDesign branding"
    },
    {
    icon:<FaHeadphonesAlt/>,
    title:"Premium support"
    }
]
export const priceData4=[
    {
     icon:<AiOutlineUser />,
     title:"Start with 3 users"
    },
    {
     icon:<AiFillFile />,
    title:"Unlimited Projects"
    },
    {
    icon:<AiFillFile />,
    title:"10 active user test"
    },
    {
     icon:<AiOutlineDownload />,
     title:"Download prototypes or designs"
    },
    {
    icon:<ImPriceTag />,
    title:"Remove HostDesign branding"
    },
    {
    icon:<FaHeadphonesAlt/>,
    title:"Premium support"
    },
    {
        icon:<AiFillFile />,
        title:"Invite-only projects"
    },
    {
        icon:<AiFillSetting />,
        title:"Advanced security settings"
    },
    {
        icon:<AiFillCloud />,
        title:"Single Sign-On(SSO)"
    },
    {
     icon:<RiCheckboxBlankFill/>,
     title:"Invoice/custom billing"
    }
]

export const panel1Data = [
    {
        title:"Free",
        desc:"Bring your ideas to life",
        price:"$0 / month",
        btn:"Start with free",
        list:priceData1
    },
    {
        title:"Pro",
        desc:"Best for individuals",
        price:"$12 / month",
        btn:"Choose plan",
        list:priceData2
    },
    {
        title:"Team",
        desc:"Best for small teams",
        price:"$42 / month",
        btn:"Start 7 days free trial",
        list:priceData3
    },
    {
        title:"Enterprise",
        desc:"Built for large orgs",
        price:"Let's chat",
        btn:"Request a Quote",
        list:priceData4
    }
]
export const panel2Data = [
    {
        title:"Free",
        desc:"Bring your ideas to life",
        price:"$20 / year",
        btn:"Start with free",
        list:priceData1
    },
    {
        title:"Pro",
        desc:"Best for individuals",
        price:"$100 / year",
        btn:"Choose plan",
        list:priceData2
    },
    {
        title:"Team",
        desc:"Best for small teams",
        price:"$120 / year",
        btn:"Start 7 days free trial",
        list:priceData3
    },
    {
        title:"Enterprise",
        desc:"Built for large orgs",
        price:"Let's chat",
        btn:"Request a Quote",
        list:priceData4
    }
]